/** @jsx jsx */
/* eslint-disable react/jsx-props-no-spreading */
import { jsx, Flex } from 'theme-ui'

export const HGroup = (props) => (
  <Flex sx={{ flexDirection: 'row', alignItems: 'center' }} {...props} />
)
